import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface HeaderWalletDrawerSettings {
  shouldHideSmallBalances: boolean;
}

export interface HeaderWalletDrawerState {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
  settings: HeaderWalletDrawerSettings;
  updateSettings: (partial: Partial<HeaderWalletDrawerSettings>) => void;
}

export const useHeaderWalletDrawerStore = create<HeaderWalletDrawerState>()(
  persist(
    (set) => ({
      isDrawerOpen: false,
      setIsDrawerOpen: (isOpen) => set({ isDrawerOpen: isOpen }),
      openDrawer: () => set({ isDrawerOpen: true }),
      closeDrawer: () => set({ isDrawerOpen: false }),
      toggleDrawer: () => set((state) => ({ isDrawerOpen: !state.isDrawerOpen })),
      settings: {
        shouldHideSmallBalances: false,
      },
      updateSettings: (partial) => set((state) => ({ settings: { ...state.settings, ...partial } })),
    }),
    {
      name: 'header-wallet-drawer-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ settings: state.settings }),
    }
  )
);
